// @router
import { RouteConfig } from "vue-router";

const newContainer = () => import("@/layouts/Default.vue");
import addAllTicket from "./../views/allTicket/addAllTicket.vue";
import addTicket from "./../views/ticket/addTicket.vue";
import addTicketByOperator from "./../views/ticket/addTicketByOperator.vue";
import allTicketSearch from "./../views/allTicket/allticketSearch.vue";
import allTicketUsersSearch from "./../views/allTicketUsers/allTicketUsersSearch.vue";
import contactUsSearch from "../views/contactUs/contactUsSearch.vue";
import editAllTicket from "./../views/allTicket/editAllTicket.vue";
import editContactUs from "../views/contactUs/editContactUs.vue";
import editTicket from "./../views/ticket/editTicket.vue";
import faqPage from "../views/faq/faqPage.vue";
import newAllTicketSearch from "./../views/allTicket/newAllTicketSearch.vue";
import newEditAllTicket from "./../views/allTicket/newEditAllTicket.vue";
import newEditTicket from "./../views/ticket/newEditTicket.vue";
import newTicketSearch from "./../views/ticket/newTicketSearch.vue";
import routerParent from "@/components/base/routerParrent.vue";
import ticketAccessSearch from "./../views/ticketAccess/search.vue";
import ticketSearch from "./../views/ticket/ticketSearch.vue";

export const ticketRoutes: RouteConfig[] = [
  {
    meta: {
      label: "خانه",
      requiresAuth: true,
    },
    path: "/ticket",
    name: "dynamic_home",
    component: newContainer,
    children: [
      {
        meta: {
          label: "پشتیبانی",
          requiresAuth: true,
        },
        path: "my-ticket",
        name: "user_ticket_search",
        component: routerParent,
        children: [
          {
            path: "search",
            name: "user_ticket_search",
            component: newTicketSearch,
            meta: {
              label: "درخواست‌های من",
              requiresAuth: true,
            },
          },
          {
            path: "add",
            name: "user_add_ticket",
            component: addTicket,
            meta: {
              label: "ارسال درخواست جدید",
              requiresAuth: true,
            },
          },
          {
            path: "edit/:code",
            name: "user_edit_ticket",
            component: newEditTicket,
            meta: {
              label: "ویرایش درخواست",
              requiresAuth: true,
            },
          },
          {
            path: "add-ticket-by-operator",
            name: "operator_add_ticket",
            component: addTicketByOperator,
            meta: {
              label: "ایجاد درخواست جدید توسط پشتیبان",
              requiresAuth: true,
            },
          },
          {
            path: "protest",
            name: "add_protest_ticket",
            component: addTicket,
            meta: {
              label: "ثبت اعتراض",
              requiresAuth: true,
            },
          },
          {
            path: "faq",
            name: "faqPage",
            component: faqPage,
            meta: {
              label: "سوال‌های متداول",
              requiresAuth: true,
            },
          },
        ],
      },
      {
        meta: {
          label: "پشتیبانی",
          requiresAuth: true,
        },
        path: "all-ticket",
        name: "all_ticket_search",
        component: routerParent,
        children: [
          {
            meta: {
              label: "بررسی درخواست‌ها",
              requiresAuth: true,
            },
            path: "search",
            name: "all_ticket_search",
            component: newAllTicketSearch,
          },
          {
            meta: {
              label: "درخواست‌ها بر حسب کاربر",
              requiresAuth: true,
            },
            path: "by-users",
            name: "all_ticket_users_search",
            component: allTicketUsersSearch,
          },
          {
            meta: {
              label: "ارسال درخواست جدید",
              requiresAuth: true,
            },
            path: "add",
            name: "add_all_ticket",
            component: addAllTicket,
          },
          {
            meta: {
              label: "ویرایش درخواست ",
              requiresAuth: true,
            },
            path: "edit/:code",
            name: "edit_all_ticket",
            component: newEditAllTicket,
          },
        ],
      },
      {
        meta: {
          label: "پشتیبانی",
          requiresAuth: true,
        },
        path: "ticket-access",
        name: "ticket_access",
        component: routerParent,
        children: [
          {
            meta: {
              label: "دسترسی درخواست‌ها",
              requiresAuth: true,
            },
            path: "search",
            name: "ticket_access",
            component: ticketAccessSearch,
          },
        ],
      },
      {
        meta: {
          label: "پشتیبانی",
          requiresAuth: true,
        },
        path: "contact-us",
        name: "contact_us_search",
        component: routerParent,
        children: [
          {
            meta: {
              label: "مشکل های ورود",
              requiresAuth: true,
            },
            path: "search",
            name: "contact_us_search",
            component: contactUsSearch,
          },
          {
            meta: {
              label: "ویرایش مشکل های ورود",
              requiresAuth: true,
            },
            path: "edit/:id",
            name: "edit_contact_us",
            component: editContactUs,
          },
        ],
      },
    ],
  },
  /* {
      path: '/ticket',
      name: 'user_ticket_search',
      redirect: "/ticket/my-ticket",
      meta: {
        label: "درخواست"
      },
      component: newContainer,
      children: [
        {
          path: 'my-ticket',
          name: 'user_ticket_search',
          component: newTicketSearch,
          meta: {
            label: "درخواست‌های من",
            requiresAuth: true
          },
        },
        {
          path: 'addTicket',
          name: 'user_add_ticket',
          component: addTicket,
          meta: {
            label: "ارسال درخواست جدید",
            requiresAuth: true
          },
        },
        {
          path: 'edit/:code',
          name: 'user_edit_ticket',
          component: newEditTicket,
          meta: {
            label: "ویرایش درخواست ",
            requiresAuth: true
          },
        },
        {
          path: 'addTicketByOperator',
          name: 'operator_add_ticket',
          component: addTicketByOperator,
          meta: {
            label: "ایجاد درخواست جدید توسط پشتیبان",
            requiresAuth: true
          },
        },
        {
          path: 'protest',
          name: 'add_protest_ticket',
          component: addTicket,
          meta: {
            label: "ثبت اعتراض",
            requiresAuth: true
          },
        },
        {
          path: 'faq',
          name: 'faqPage',
          component: faqPage,
          meta: {
            label: "سوال‌های متداول",
            requiresAuth: true
          },
        },
        {
          path: 'contactUs',
          name: 'contact_us_list',
          redirect: '/support/contactUs/search',
          component: routerParent,
          meta: {
            label: "در خواست پشتیبانی",
            requiresAuth: true
          },
          children: [
            {
            path: 'search',
            name: 'contact_us_search',
            component: contactUsSearch,
            meta: {
              label: "لیست در خواست‌ها",
              requiresAuth: true
            },
          },{
            path: 'edit/:id',
            name: 'edit_contact_us',
            component: editContactUs,
            meta: {
              label: "ویرایش در خواست‌ها",
              requiresAuth: true
            },
          }]
        }
      ]
  }, */
  /* {
    path: '/allticket',
    name: 'all_ticket',
    redirect: "/allticket/allTicketSearch",
    meta: {
      label: "درخواست"
    },
    component: newContainer,
    children: [
      {
        path: 'addAllTicket',
        name: 'add_all_ticket',
        component: addAllTicket,
        meta: {
          label: "ارسال درخواست جدید",
          requiresAuth: true
        },
      },
      {
        path: 'allTicketSearch',
        name: 'all_ticket_search',
        component: newAllTicketSearch,
        meta: {
          label: "لیست درخواست‌ها",
          requiresAuth: true
        },
      },
      {
        path: 'allTicketTUsers',
        name: 'all_ticket_users_search',
        component: allTicketUsersSearch,
        meta: {
          label: "لیست درخواست‌ها",
          requiresAuth: true
        },
      },
      {
        path: 'edit/:code',
        name: 'edit_all_ticket',
        component: newEditAllTicket,
        meta: {
          label: "ویرایش درخواست ",
          requiresAuth: true
        },
      },
    ]
  }, */
  /* {
    path: '/ticket-access',
    name: 'ticket_access',
    redirect: "/ticket-access/search",
    meta: {
      label: "دسترسی درخواست‌ها"
    },
    component: newContainer,
    children: [
      {
        path: 'search',
        name: 'ticket_access_search',
        component: ticketAccessSearch,
        meta: {
          label: "لیست مشاهده دسترسی‌ها",
          requiresAuth: true
        },
      },
    ]
  }, */
];
